/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * alternative sources of the video
 */
export type AlternativeLanguageSources = AlternativeLanguageSource[];
/**
 * define colors of uiElement on player
 */
export type Colors = Color[];
/**
 * define controls for specific devices
 */
export type SpecificDevices = SpecificDevice[];
/**
 * Define responsive rules for player in defining width and className for each rule. className will be added to the player container when the width is less than the rule width. className can be used to apply custom css for each rule.
 */
export type Responsive = ResponsiveItem[];
/**
 * Define key for shortcuts
 */
export type Shortcuts = Shortcut[];
/**
 * position of each control of the plugin
 */
export type PluginPositionsOfControls = PluginPositionOfControl[];
/**
 * list of plugins
 */
export type Plugins = PluginItem[];

export interface Player {
  initOptions?: InitOptions;
  pluginItem?: PluginItem;
  state?: State;
  events?: Events;
  notificationAction?: NotificationAction;
  toggleControlsChangedEvents?: ToggleControlsChangedEvents;
  qualityLevel?: QualityLevel;
  qualityLevels?: QualityLevels;
  qualityLevelCurrentIndex?: QualityLevelCurrentIndex;
  textTrack?: TextTrack;
  audioTrack?: AudioTrack;
  videoTrack?: VideoTrack;
  sourceTypes?: SourceTypes;
  sizePlayerEvents?: SizePlayerEvents;
  stateChangedEvents?: StateChangedEvents;
  qualityLevelEvents?: QualityLevelEvents;
  audioTrackEvents?: AudioTrackEvents;
  videoTrackEvents?: VideoTrackEvents;
  currentTimeEvents?: CurrentTimeEvents;
  textTrackEvents?: TextTrackEvents;
  textTrackKind?: TextTrackKind;
  hooks?: Hooks;
  controlsPosition?: ControlsPosition;
  bigButtonPosition?: BigButtonPosition;
  provider?: Provider;
  shortcuts?: Shortcuts;
  responsiveItem?: ResponsiveItem;
  controlComponentItem?: ControlComponentItem;
  controlsSettings?: ControlsSettings;
  liveSettings?: LiveSettings;
  dvrSettings?: DvrSettings;
  pluginControlPosition?: PluginControlPosition;
  pluginPositionsOfControls?: PluginPositionsOfControls;
  pluginPositionOfControl?: PluginPositionOfControl;
  hlsProviderOptions?: HlsProviderOptions;
  [k: string]: unknown;
}
export interface InitOptions {
  source: Source;
  /**
   * url of the poster image
   */
  poster?: string;
  posterFit?: PosterFit;
  autoplay?: Autoplay;
  /**
   * is video is set to be in muted at start
   */
  muted?: boolean;
  /**
   * define player for background use
   */
  background?: boolean;
  /**
   * if you have a video without audio track, you can set this parameter to `false`, this allows to hide volume controls
   */
  audio?: boolean;
  fit?: Fit;
  /**
   * you can force ratio of the player, -1 is default, we don't force anything and let css integrator do the job with his own container
   */
  ratio?: number;
  /**
   * background color of the player
   */
  bgColor?: string;
  /**
   * color of the controls, but if if you want more custom, you can define colors object
   */
  controlsColor?: string;
  colors?: Colors;
  /**
   * loop on video
   */
  loop?: boolean;
  /**
   * show big button play at end of video
   */
  rewind?: boolean;
  /**
   * width of the player
   */
  width?: number;
  /**
   * height of the player
   */
  height?: number;
  controls?: Controls;
  initialValues?: InitialValues;
  locale?: Locale;
  title?: string;
  logo?: Logo;
  cta?: Cta;
  providersOptions?: ProvidersOptions;
  /**
   * hook that permit to update settings before player init
   */
  onBeforeInit?: any;
  js?: string;
  css?: string;
  responsive?: Responsive;
  shortcuts?: Shortcuts;
  liveSettings?: LiveSettings;
  dvrSettings?: DvrSettings;
  plugins?: Plugins;
  customProvider?: CustomProvider;
  [k: string]: unknown;
}
/**
 * source item data
 */
export interface Source {
  /**
   * url of the video
   */
  url?: string;
  playbackMode?: PlaybackMode;
  /**
   * start time of the video in seconds
   */
  startTime?: number;
  /**
   * end time of the video in seconds
   */
  endTime?: number;
  streamType?: StreamType;
  /**
   * textTracks of the video
   */
  textTracks?: TextTrack[];
  sourceType?: SourceType;
  alternativeLanguageSources?: AlternativeLanguageSources;
  [k: string]: unknown;
}
/**
 * textTrack item data
 */
export interface TextTrack {
  /**
   * textTrack item show on player controller
   */
  label: string;
  /**
   * src file
   */
  src: string;
  /**
   * all data of the textTrack
   */
  srclang: string;
  kind: TextTrackKind;
  /**
   * index of the textTrack
   */
  index?: number;
  /**
   * default textTrack, if true, it will be selected by default (only one textTrack can be default, [initalValues](/docs/api/InitialValues) can also do the job)
   */
  default?: boolean;
  /**
   * all data of the textTrack
   */
  data?: {
    [k: string]: unknown;
  };
  /**
   * HTMLTrackElement data
   */
  trackElement?: HTMLTrackElement;
  [k: string]: unknown;
}
/**
 * alternative sources of the video
 */
export interface AlternativeLanguageSource {
  url: string;
  language: string;
  code?: string;
  /**
   * default source to play
   */
  default?: boolean;
  [k: string]: unknown;
}
export interface Color {
  value?: string;
  elements?: UiElement[];
  [k: string]: unknown;
}
/**
 * controls object description
 */
export interface Controls {
  /**
   * show controls on video
   */
  show?: boolean;
  settings?: ControlsSettings;
  progressBar?: ProgressBar;
  bigButton?: BigButton;
  /**
   * define controls to hide
   */
  hideList?: Control[];
  /**
   * hide some controls when it's live
   */
  liveAutoHide?: Control[];
  /**
   * left controls
   */
  topLeft?: Control[];
  /**
   * right controls
   */
  topRight?: Control[];
  /**
   * left controls
   */
  bottomLeft?: Control[];
  /**
   * right controls
   */
  bottomRight?: Control[];
  /**
   * controls in a sub menu item
   */
  subMenu?: ControlSubmenu[];
  /**
   * controls in a sub menu item
   */
  middle?: ControlMiddle[];
  specificDevices?: SpecificDevices;
  [k: string]: unknown;
}
/**
 * settings about controls on video
 */
export interface ControlsSettings {
  /**
   * always show bottom controls
   */
  stickyBottom?: boolean;
  /**
   * always show top controls
   */
  stickyTop?: boolean;
  textButton?: TextButton;
  click?: ClickAction;
  doubleClick?: ClickAction;
  volume?: Volume;
  /**
   * define playback rates
   */
  playbackRates?: number[];
  /**
   * interval of seek control
   */
  seekControlInterval?: number;
  /**
   * hide controls after timeout in milli seconds, -1 if you don't want to hide it
   */
  hideAfterInactivityTimeout?: number;
  [k: string]: unknown;
}
/**
 * settings of control volume
 */
export interface Volume {
  /**
   * show volume range
   */
  range?: boolean;
  orientation?: Orientation;
  [k: string]: unknown;
}
/**
 * settings of progress bar
 */
export interface ProgressBar {
  /**
   * show progress bar
   */
  show?: boolean;
  position?: ProgressBarPosition;
  /**
   * show hover element on progress bar
   */
  hoverShow?: boolean;
  hover?: Hover;
  [k: string]: unknown;
}
/**
 * settings of big button
 */
export interface BigButton {
  /**
   * show big button
   */
  show?: boolean;
  /**
   * show big button only on first time
   */
  firstTimeOnly?: boolean;
  position?: BigButtonPosition;
  /**
   * show control when big button is displayed
   */
  showControlBigButtonDisplayed?: boolean;
  /**
   * show big button mute
   */
  showMute?: boolean;
  /**
   * shrink big button mute after timeout in milli seconds, -1 if you don't want to shrink it
   */
  shrinkMuteAfterTimeout?: number;
  /**
   * hide mute on mouse out
   */
  stickyMute?: boolean;
  [k: string]: unknown;
}
/**
 * specific device settings, if device match, controls will be override
 */
export interface SpecificDevice {
  device: Device;
  /**
   * The responsive size name that matches a key in the responsive object.
   */
  size?: string;
  controls: Controls1;
  [k: string]: unknown;
}
/**
 * device info, please refer to https://github.com/faisalman/ua-parser-js/tree/1.0.35#documentation
 */
export interface Device {
  /**
   * os name
   */
  osName?: string;
  /**
   * os version
   */
  osVersion?: string;
  /**
   * browser name
   */
  browserName?: string;
  /**
   * browser version
   */
  browserVersion?: string;
  /**
   * device model
   */
  deviceModel?: string;
  /**
   * device type
   */
  deviceType?: string;
  /**
   * device vendor
   */
  deviceVendor?: string;
  [k: string]: unknown;
}
/**
 * controls on video
 */
export interface Controls1 {
  /**
   * show controls on video
   */
  show?: boolean;
  settings?: ControlsSettings;
  progressBar?: ProgressBar;
  bigButton?: BigButton;
  /**
   * define controls to hide
   */
  hideList?: Control[];
  /**
   * hide some controls when it's live
   */
  liveAutoHide?: Control[];
  /**
   * left controls
   */
  topLeft?: Control[];
  /**
   * right controls
   */
  topRight?: Control[];
  /**
   * left controls
   */
  bottomLeft?: Control[];
  /**
   * right controls
   */
  bottomRight?: Control[];
  /**
   * controls in a sub menu item
   */
  subMenu?: ControlSubmenu[];
  /**
   * controls in a sub menu item
   */
  middle?: ControlMiddle[];
  specificDevices?: SpecificDevices;
  [k: string]: unknown;
}
/**
 * initial values
 */
export interface InitialValues {
  /**
   * default volume of the video
   */
  volume?: number;
  /**
   * define an audio track by default. if autoSelectWithViewerLanguage is true, this value bypass autoSelectWithViewerLanguage
   */
  audioTrackIndex?: number;
  /**
   * define a video track by default. if autoSelectWithViewerLanguage is true, this value bypass autoSelectWithViewerLanguage
   */
  videoTrackIndex?: number;
  /**
   * define a textTrack track by default. if autoSelectWithViewerLanguage is true, this value bypass autoSelectWithViewerLanguage
   */
  textTrackIndex?: number;
  /**
   * define a quality level Video by default
   */
  qualityLevelVideoIndex?: number;
  /**
   * define a quality level Audio by default
   */
  qualityLevelAudioIndex?: number;
  /**
   * auto select language with viewer language, this concerns audioTrackIndex, videoTrackIndex, textTrackIndex, player inspect data of each tracks and initialize the player with the best match.
   */
  autoSelectWithViewerLanguage?: boolean;
  [k: string]: unknown;
}
/**
 * locale object description
 */
export interface Locale {
  /**
   * browser-based auto-detection for language
   */
  automatic_detection?: boolean;
  /**
   * define code lang for video
   */
  lang?: string;
  /**
   * define code lang for fallback if lang choosen or autodetected not exist
   */
  fallback_lang?: string;
  /**
   * define custom translations, follow this link to know how to define translations object: [Custom translation example](/docs/tutorial/examples/custom-text-and-language)
   */
  translations?: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^[a-zA-Z]+$".
     */
    [k: string]: {
      [k: string]: unknown;
    };
  };
  hooks?: Hooks;
  [k: string]: unknown;
}
/**
 * hooks for translations: hooks are method that you can use to override default translations with specific data
 */
export interface Hooks {
  /**
   * Hook for override quality level label
   */
  qualityLevelLabel?: any;
  /**
   * Hook for override textTrack label
   */
  textTrackLabel?: any;
  /**
   * Hook for override audio track label
   */
  audioTrackLabel?: any;
  /**
   * Hook for override audio track label
   */
  videoTrackLabel?: any;
  /**
   * Hook for error handling
   */
  errorLabel?: any;
  [k: string]: unknown;
}
/**
 * logo object description
 */
export interface Logo {
  /**
   * url of the logo image
   */
  url: string;
  position?: LogoPosition;
  /**
   * hide logo on mouse out
   */
  hideOnMouseOut?: boolean;
  /**
   * max width of the logo in percentage of the player width
   */
  maxWidth?: number;
  [k: string]: unknown;
}
/**
 * locale object description
 */
export interface Cta {
  /**
   * cta label
   */
  title?: string;
  /**
   * cta url
   */
  url?: string;
  [k: string]: unknown;
}
/**
 * provider options
 */
export interface ProvidersOptions {
  hls?: HlsProviderOptions;
  /**
   * hls native provider options, see https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning
   */
  hlsNative?: {
    [k: string]: unknown;
  };
  /**
   * dash provider options, NOT available yet
   */
  dash?: {
    [k: string]: unknown;
  };
  /**
   * dash provider options, see https://cdn.dashjs.org/latest/jsdoc/module-Settings.html
   */
  dashNative?: {
    [k: string]: unknown;
  };
  [k: string]: unknown;
}
/**
 * hls provider options, NOT available yet
 */
export interface HlsProviderOptions {
  /**
   * prevent loop back on live stream
   */
  preventLoopBack?: boolean;
  /**
   * reload on fatal error after timeout in milli seconds, -1 to disable it
   */
  reloadOnFatalError?: number;
  [k: string]: unknown;
}
/**
 * responsive item
 */
export interface ResponsiveItem {
  /**
   * Width max for custom or standard responsive rule css
   */
  width: number;
  /**
   * Height max for custom or standard responsive rule css
   */
  height?: number;
  className: string;
  [k: string]: unknown;
}
/**
 * Define key for shortcut
 */
export interface Shortcut {
  action?: ShortcutAction;
  key?: string;
  altKey?: boolean;
  shiftKey?: boolean;
  ctrlKey?: boolean;
  [k: string]: unknown;
}
/**
 * live settings
 */
export interface LiveSettings {
  /**
   * retry if no live, useful for live stream that start later, we don't want to show error message if no live yet
   */
  retryIfNoLive?: boolean;
  /**
   * timeout for retry if no live (in milli-seconds)
   */
  retryTimeout?: number;
  [k: string]: unknown;
}
/**
 * dvr setup
 */
export interface DvrSettings {
  /**
   * show the specific dvr control
   */
  showControl?: boolean;
  /**
   * delay still considering live (in seconds)
   */
  delayStillConsideringLive?: number;
  [k: string]: unknown;
}
/**
 * plugin object
 */
export interface PluginItem {
  /**
   * the plugin class
   */
  pluginClass?: any;
  positions?: PluginPositionsOfControls;
  /**
   * plugin options
   */
  options?: {
    [k: string]: unknown;
  };
  [k: string]: unknown;
}
export interface PluginPositionOfControl {
  /**
   * name of the control
   */
  name?: string;
  position?: PluginControlPosition;
  [k: string]: unknown;
}
/**
 * position of the control plugin
 */
export interface PluginControlPosition {
  position: ControlsPosition;
  /**
   * Position of the control plugin : 0 for start, -1 for end, or a specific integer
   */
  index?: number;
  [k: string]: unknown;
}
/**
 * custom provider
 */
export interface CustomProvider {
  /**
   * the plugin class
   */
  pluginClass?: any;
  positions?: PluginPositionsOfControls;
  /**
   * plugin options
   */
  options?: {
    [k: string]: unknown;
  };
  [k: string]: unknown;
}
/**
 * qualityLevel item data
 */
export interface QualityLevel {
  /**
   * qualityLevel in MB/s
   */
  bitrate: number;
  /**
   * dimension of video width
   */
  width?: number;
  /**
   * dimension of video height
   */
  height?: number;
  /**
   * index of the qualityLevel
   */
  index?: number;
  /**
   * qualityLevel item show on player controller
   */
  label?: string;
  kind?: QualityLevelKind;
  /**
   * all data of the qualityLevel
   */
  data?: {
    [k: string]: unknown;
  };
  [k: string]: unknown;
}
/**
 * quality levels list by media type
 */
export interface QualityLevels {
  /**
   * video qualityLevels
   */
  video: QualityLevel[];
  /**
   * audio qualityLevels
   */
  audio: QualityLevel[];
  [k: string]: unknown;
}
/**
 * quality level current index by media type
 */
export interface QualityLevelCurrentIndex {
  video: number;
  audio: number;
  [k: string]: unknown;
}
/**
 * audiotrack item data
 */
export interface AudioTrack {
  /**
   * audiotrack label
   */
  label: string;
  /**
   * all data of the audiotrack
   */
  data?: {
    [k: string]: unknown;
  };
  /**
   * index of the audiotrack
   */
  index?: number;
  [k: string]: unknown;
}
/**
 * video track item data
 */
export interface VideoTrack {
  /**
   * video track label
   */
  label: string;
  /**
   * all data of the video track
   */
  data?: {
    [k: string]: unknown;
  };
  /**
   * index of the video track
   */
  index?: number;
  [k: string]: unknown;
}
/**
 * size events
 */
export interface SizePlayerEvents {
  size: string;
  width: number;
  height: number;
  [k: string]: unknown;
}
/**
 * state changed event
 */
export interface StateChangedEvents {
  previousState: State;
  newState: State;
  [k: string]: unknown;
}
/**
 * quality level changed event
 */
export interface QualityLevelEvents {
  qualityLevel: QualityLevel;
  index: number;
  isAutoQualityLevel: boolean;
  mediaType?: string;
  [k: string]: unknown;
}
/**
 * audio track changed event
 */
export interface AudioTrackEvents {
  audioTrack: AudioTrack;
  index: number;
  [k: string]: unknown;
}
/**
 * video track changed event
 */
export interface VideoTrackEvents {
  videoTrack: VideoTrack;
  index: number;
  [k: string]: unknown;
}
/**
 * current time changed event
 */
export interface CurrentTimeEvents {
  currentTime: number;
  currentTimeInPercentage: number;
  duration: number;
  [k: string]: unknown;
}
/**
 * textTrack changed event
 */
export interface TextTrackEvents {
  textTrack: TextTrack;
  index: number;
  [k: string]: unknown;
}
/**
 * control component item
 */
export interface ControlComponentItem {
  name?: Control;
  pluginName?: string;
  controlName?: string;
  position?: PluginControlPosition;
  plugin?: any;
  [k: string]: unknown;
}

/**
 * is live or vod or dvr (default is defined by the stream, this option is especially useful for DVR)
 */
export const enum PlaybackMode {
  LIVE = "live",
  VOD = "vod",
  DVR = "dvr"
}
/**
 * type of the video (mp4, m3u8, etc.)
 */
export const enum StreamType {
  MP4 = "mp4",
  DASH = "dash",
  WEBRTC = "webrtc",
  HLS = "hls"
}
/**
 * kind of textTrack
 */
export const enum TextTrackKind {
  SUBTITLES = "subtitles",
  CAPTIONS = "captions",
  DESCRIPTIONS = "descriptions",
  CHAPTERS = "chapters",
  METADATA = "metadata"
}
/**
 * type of source, for now url and alternativeLanguage are available
 */
export const enum SourceType {
  URL = "url",
  ALTERNATIVE_LANGUAGE = "alternativeLanguage",
  PLAYLIST = "playlist",
  FALLBACK = "fallback"
}
/**
 * fit of the poster image
 */
export const enum PosterFit {
  CONTAIN = "contain",
  COVER = "cover"
}
/**
 * start video automatically
 */
export const enum Autoplay {
  YES = "yes",
  NO = "no",
  VIEWABLE = "viewable"
}
/**
 * video fit depending with player
 */
export const enum Fit {
  CONTAIN = "contain",
  COVER = "cover"
}
/**
 * ui element of player
 */
export const enum UiElement {
  PROGRESS_BAR = "progress-bar",
  TITLE = "title",
  CONTROL_ICON = "control-icon",
  TEXT = "text",
  TOOLTIP_BACKGROUND = "tooltip-background"
}
/**
 * how display text for button
 */
export const enum TextButton {
  HIDE = "hide",
  HOVER = "hover",
  REPLACE_BUTTON = "replace-button",
  BOTH = "both"
}
/**
 * action available on click and double click
 */
export const enum ClickAction {
  PLAY = "play",
  PAUSE = "pause",
  FULLSCREEN = "fullscreen",
  CONTROLS = "controls"
}
/**
 * orientation of volume range on hover
 */
export const enum Orientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape"
}
/**
 * position of the progress bar
 */
export const enum ProgressBarPosition {
  BOTTOM = "bottom",
  CENTER_BOTTOM_CONTROLS = "center-bottom-controls",
  BEFORE_BOTTOM_CONTROLS = "before-bottom-controls",
  AFTER_BOTTOM_CONTROLS = "after-bottom-controls"
}
/**
 * information shown on progressbar hover
 */
export const enum Hover {
  TIME = "time"
}
/**
 * big button position list
 */
export const enum BigButtonPosition {
  TOP_LEFT = "topLeft",
  TOP_RIGHT = "topRight",
  MIDDLE = "middle"
}
/**
 * control item data
 */
export const enum Control {
  PLAY = "play",
  VOLUME = "volume",
  FULLSCREEN = "fullscreen",
  TEXTTRACKS_SELECTOR = "texttracks_selector",
  AUDIOTRACKS_SELECTOR = "audiotracks_selector",
  VIDEOTRACKS_SELECTOR = "videotracks_selector",
  QUALITYLEVELS_SELECTOR = "qualityLevels_selector",
  PLAYBACKRATES_SELECTOR = "playbackRates_selector",
  SEEK_CONTROL_FORWARD = "seek_control_forward",
  SEEK_CONTROL_REWIND = "seek_control_rewind",
  PIP = "pip",
  AIR_PLAY = "airplay",
  TIME_INFO = "time_info",
  PROGRESS_BAR = "progress_bar",
  SUB_MENU = "sub_menu",
  TITLE = "title",
  LIVE_DVR_INDICATOR = "live_dvr_indicator",
  PLUGIN_SKELETON = "plugin_skeleton"
}
/**
 * control item data available for sub menu
 */
export const enum ControlSubmenu {
  TEXTTRACKS_SELECTOR = "texttracks_selector",
  AUDIOTRACKS_SELECTOR = "audiotracks_selector",
  VIDEOTRACKS_SELECTOR = "videotracks_selector",
  QUALITYLEVELS_SELECTOR = "qualityLevels_selector",
  PLAYBACKRATES_SELECTOR = "playbackRates_selector"
}
/**
 * control item data available on middle zone
 */
export const enum ControlMiddle {
  PLAY = "play",
  PAUSE = "pause",
  SEEK_CONTROL_FORWARD = "seek_control_forward",
  SEEK_CONTROL_REWIND = "seek_control_rewind"
}
/**
 * position of the logo
 */
export const enum LogoPosition {
  TOP_LEFT = "top-left",
  TOP_RIGHT = "top-right",
  BOTTOM_LEFT = "bottom-left",
  BOTTOM_RIGHT = "bottom-right"
}
/**
 * action available for shortcut
 */
export const enum ShortcutAction {
  PLAY = "play",
  FULLSCREEN = "fullscreen",
  MUTE = "mute"
}
/**
 * control position list
 */
export const enum ControlsPosition {
  TOP_LEFT = "topLeft",
  TOP_RIGHT = "topRight",
  BOTTOM_LEFT = "bottomLeft",
  BOTTOM_RIGHT = "bottomRight",
  MIDDLE = "middle",
  HIDE_LIST = "hideList",
  SUB_MENU = "subMenu",
  PROGRESS_BAR = "progessBar",
  FULL = "full"
}
/**
 * state of the player
 */
export const enum State {
  BUFFERING = "buffering",
  IDLE = "idle",
  COMPLETE = "complete",
  PAUSED = "paused",
  PLAYING = "playing",
  ERROR = "error",
  LOADING = "loading",
  STALLED = "stalled",
  ENDED = "ended"
}
/**
 * event of the player
 */
export const enum Events {
  INIT = "init",
  READY = "ready",
  STATE_CHANGED = "stateChanged",
  PLAY = "play",
  PAUSE = "pause",
  CURRENT_TIME = "currentTime",
  MUTED = "muted",
  SEEKING = "seeking",
  SEEKED = "seeked",
  VOLUME_CHANGED = "volumeChanged",
  SOURCE_CHANGED = "sourceChanged",
  QUALITYLEVEL_CHHANGED = "qualityLevelChanged",
  DURATION_CHANGED = "durationChanged",
  TEXTTRACK_CHANGED = "textTrackChanged",
  AUDIOTRACK_CHANGED = "audioTrackChanged",
  VIDEOTRACK_CHANGED = "videoTrackChanged",
  FULLSCREEN_CHANGED = "fullscreenChanged",
  PLAYBACKRATE_CHANGED = "playbackRateChanged",
  SEEK_CONTROL_INTERVAL_CHANGED = "seekControlIntervalChanged",
  PIP_CHANGED = "pipChanged",
  AIRPLAY_AVAILABILITY_CHANGED = "airPlayAvailabilityChanged",
  PROGRESS = "progress",
  ERROR = "error",
  ALL = "all",
  NOTIFICATION_ACTION = "notificationAction",
  TOGGLE_CONTROL_MENU = "toggleControlMenu",
  SHOW_POSTER = "showPoster",
  TOGGLE_CONTROLS = "toggleControls",
  CHANGE_SIZE = "changeSize",
  BIG_BUTTON_CHANGED = "bigButtonChanged",
  MOUSE_OVER = "mouseOver",
  PLAYER_VISIBLE = "playerVisible",
  END = "end",
  CLICK_CONTROL = "clickControl",
  TOGGLE_CONTROLS_CHANGED = "toggleControlsChanged",
  DESTROY = "destroy"
}
/**
 * notification to show player when action triggered
 */
export const enum NotificationAction {
  PLAY = "play",
  PAUSE = "pause"
}
/**
 * controls bar visibity status
 */
export const enum ToggleControlsChangedEvents {
  SHOW = "show",
  HIDE = "hide"
}
/**
 * kind of qualityLevel
 */
export const enum QualityLevelKind {
  VIDEO = "video",
  AUDIO = "audio"
}
/**
 * type of source, for now url and alternativeLanguage are available
 */
export const enum SourceTypes {
  URL = "url",
  ALTERNATIVE_LANGUAGE = "alternativeLanguage",
  PLAYLIST = "playlist",
  FALLBACK = "fallback"
}
/**
 * provider available
 */
export const enum Provider {
  Html5 = "html5",
  Hls = "hls",
  Dash = "dash",
  WebRTC = "webrtc"
}
